import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const DropdownGameProviderStyle = {
  container: (visible: boolean) => css`
    background: linear-gradient(
      180deg,
      rgba(248, 250, 253, 0.98) 0%,
      rgba(228, 236, 245, 0.98) 100%
    );
    backdrop-filter: blur(16px);
    box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.14);
    border-bottom: 2px solid rgba(255, 255, 255, 0.85);
    position: fixed;
    opacity: ${visible ? 1 : 0};
    pointer-events: ${visible ? "visible" : "none"};
    top: 80px;
    left: 0;
    width: 100vw;
    z-index: 99;
    overflow: hidden;
    transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s ease-in-out;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.15);
      border-radius: 4px;
    }

    &:not(.drop-game-SL) {
      height: ${visible ? "240px" : "0px"} !important;
      min-height: ${visible ? "240px" : "0px"} !important;
      max-height: ${visible ? "240px" : "0px"} !important;
      overflow: hidden !important;
      overflow-x: hidden !important;
      overflow-y: hidden !important;
      overscroll-behavior: none !important;

      .content {
        height: 100%;
        overflow: hidden !important;
        padding: 0 0 10px;
      }

      .boxGame {
        overflow: hidden !important;
        padding: 0 16px 4px;
      }
    }

    &.drop-game-ES,
    &.drop-game-SB {
      height: ${visible ? "240px" : "0px"} !important;
      max-height: ${visible ? "240px" : "0px"} !important;
      overflow: hidden !important;
      overflow-y: hidden !important;

      .boxGame {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        gap: 0 24px;
        max-width: 620px;
        width: 100%;

        .itemGame {
          flex: 0 0 280px;
          max-width: 280px;
        }
        .item-image {
          width: 100%;
          height: 200px;
        }
      }
    }

    &.drop-game-LC {
      height: ${visible ? "240px" : "0px"} !important;
      max-height: ${visible ? "240px" : "0px"} !important;
      overflow: hidden !important;
      overflow-y: hidden !important;

      .boxGame {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        gap: 0 16px;
        max-width: 1140px;
        width: 100%;

        .itemGame {
          flex: 0 0 210px;
          max-width: 210px;
        }
        .item-image {
          width: 100%;
          height: 200px;
        }
      }
    }

    &.drop-game-FH,
    &.drop-game-BG {
      height: ${visible ? "240px" : "0px"} !important;
      max-height: ${visible ? "240px" : "0px"} !important;
      overflow: hidden !important;
      overflow-y: hidden !important;

      .boxGame {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        gap: 0 20px;
        max-width: 840px;
        width: 100%;

        .itemGame {
          flex: 0 0 260px;
          max-width: 260px;
        }
        .item-image {
          width: 100%;
          height: 200px;
        }
      }
    }

    &.drop-game-SL {
      height: ${visible ? "calc(100vh - 80px)" : "0px"};
      max-height: ${visible ? "calc(100vh - 80px)" : "0px"};
      overflow-y: ${visible ? "auto" : "hidden"};

      .boxGame {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 260px));
        justify-content: center;
        align-items: flex-end;
        gap: 12px 16px;
        max-width: 1360px;
        width: 100%;

        .itemGame {
          width: 100%;
          max-width: 260px;
        }
        .item-image {
          width: 100%;
          height: 255px;
        }
      }
    }

    ${media.xl} {
      .boxGame {
        padding: 0 16px;
      }
    }
  `,
  content: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 0 16px;
    width: 100%;
  `,
  boxGame: css`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin: 0 auto;
    padding: 0 16px 8px;
  `,
  itemGame: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.85;
    }

    .item-image {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 100%;

      img {
        width: 100%;
        height: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: bottom center;
        user-select: none;
      }
    }
  `,
};
